import { h } from '@stencil/core';

const Icon = ({ width = '100%', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 7.63989V13.982" stroke="#F43A36" stroke-width="2.42759" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 17.3691V17.9097" stroke="#F43A36" stroke-width="2.42759" stroke-linecap="round" stroke-linejoin="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.2971 2.55899L22.1616 18.8466C22.4138 19.315 22.4138 19.8195 22.1255 20.288C21.9814 20.5042 21.8012 20.6843 21.585 20.8285C21.3688 20.9726 21.1166 21.0086 20.8643 21.0086H3.09933C2.84709 21.0086 2.59485 20.9366 2.37864 20.8285C2.16243 20.6843 1.98226 20.5042 1.83812 20.288C1.54985 19.8195 1.54985 19.3511 1.80209 18.8466L10.7026 2.55899C10.8467 2.30675 11.0269 2.12658 11.2431 1.98244C11.4593 1.8383 11.7116 1.76624 11.9998 1.76624C12.2521 1.76624 12.5043 1.8383 12.7566 1.98244C12.9728 2.12658 13.153 2.34279 13.2971 2.55899Z"
        stroke="#F43A36"
        stroke-width="2.41925"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Icon;
